import axios from '../axios';
import { AuditEntity, IAudit } from '../types/audits';

export function getAuditsByEntity(entityId: string, entityType: AuditEntity, subEntityId?: string) {
  return axios.get<IAudit[]>('/audit/findByEntity', {
    params: { entityId, subEntityId, entityType },
  });
}
